import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NewLaneButtons, CardLaneForm, CancelCardButton, AddCardButton } from "../styles/Base";
import NewLaneTitleEditor from "../widgets/NewLaneTitleEditor";
import uuidv1 from "uuid/v1";

function NewLane({ onCancel, onAdd }) {
  const { t } = useTranslation();
  const refInput = useRef();
  const [error, setError] = useState(false);

  const getValue = () => refInput.current && refInput.current.getValue();

  const handleSubmit = () => {
    if (getValue() && getValue() !== "") {
      setError(false);
      onAdd({
        id: uuidv1(),
        title: getValue(),
      });
    } else {
      setError(true);
    }
  };

  return (
    <CardLaneForm>
      <div className={"p-4 pl-6 flex space-x-1"}>
        <NewLaneTitleEditor
          ref={refInput}
          placeholder={t("New group name")}
          onCancel={onCancel}
          onSave={handleSubmit}
          resize="vertical"
        />
        {error && <div className={"text-red-600"}>*</div>}
      </div>
      <NewLaneButtons>
        <AddCardButton onClick={handleSubmit}>{t("Create")}</AddCardButton>
        <CancelCardButton onClick={onCancel}>{t("Cancel")}</CancelCardButton>
      </NewLaneButtons>
    </CardLaneForm>
  );
}

export default NewLane;
